<div [ngClass]="{'open': !(isNavBarCollapsed | async)}">
    <!--ds-themed-header></ds-themed-header-->
    <ds-themed-navbar></ds-themed-navbar>
</div>
